import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerManagementComponent } from './banner-management.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxGalleryModule } from '@app-components/ngx-gallery-video/ngx-gallery.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';




@NgModule({
  declarations: [
    BannerManagementComponent
  ],
  exports: [
    BannerManagementComponent
  ],
  imports: [
    CommonModule,
    NgxGalleryModule,
    DragDropModule,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FileUploadModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule
  ]
})
export class BannerManagementModule { }
